// extracted by mini-css-extract-plugin
export default {"pbGlobal":"PageBuilder-module-pbGlobal-Vj4"};